module.exports = require('./helpers/bundle-url').getBundleURL('2lNV8') + "qr-bolt-driver.dd382bc9.png";